import * as React from 'react';
import classnames from 'classnames';

import ActionButton from 'components/buttons/action-button/ActionButton';
import DragAndDrop from 'components/drag-and-drop/DragAndDrop';

import { __t, applyTranslations } from 'utils/language';

import './inspirational-materials-image-upload.scss';

import type { ChangeEvent } from 'react';

applyTranslations(require('./inspirational-materials-image-upload.i18n.json'));

type Props = {
  uploadAssets: (assets: Array<File>) => void
};

const InspirationalMaterialsImageUpload = ({
  uploadAssets
}: Props) => {
  const inputFileRef = React.useRef<HTMLInputElement>(null);

  const handleUploadImages = (assets) => {
    uploadAssets(assets);
  };

  const handleClick = (syntheticEv: ChangeEvent<HTMLButtonElement>) => {
    if (inputFileRef.current) {
      inputFileRef.current.click();
    }

    syntheticEv.stopPropagation();
  };

  const handleFileChange = (syntheticEv: ChangeEvent<HTMLInputElement>) => {
    handleUploadImages([...syntheticEv.target.files ?? []]);

    /* eslint no-param-reassign: "error" */
    syntheticEv.target.value = '';
  };

  const renderDropbox = (isDragAndDropping?: boolean) => {
    const dropzoneClasses = classnames({
      'inspirational-materials-upload-image': true,
      'inspirational-materials-upload-image--hovering': isDragAndDropping
    });

    return (
      <div className={dropzoneClasses}>
        <ActionButton
          color="tertiary"
          onClick={handleClick}
        >
          <span>{__t('inspirational_materials_image_upload.choose_files_btn_text')}</span>
        </ActionButton>
        <p className="inspirational-materials-upload-image__text">{__t('inspirational_materials_image_upload.upload_text')}</p>
      </div>
    );
  };

  return (
    <React.Fragment>
      <DragAndDrop
        onDrop={handleUploadImages}
        renderOverlay={() => renderDropbox(true)}
      >
        { renderDropbox() }
      </DragAndDrop>
      <input
        type="file"
        className="inspirational-materials-upload-image__input"
        onChange={handleFileChange}
        ref={inputFileRef}
        multiple
      />
    </React.Fragment>
  );
};

export default InspirationalMaterialsImageUpload;
